module.exports = __webpack_public_path__ + "img/employee_hub_logo.c2fa2e0f.svg";